/**
 * @generated SignedSource<<f7844512924c4bc91e15a4564d4f8ba9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ServiceAvailabilityResult = "ADDON_NOT_ACTIVE" | "AVAILABLE" | "FEATURE_NOT_INCLUDED_IN_PLAN" | "NO_CREDITS" | "SHOPIFY_DEV_STORE_NOT_ALLOWED" | "TRIAL_NOT_ALLOWED" | "USE_LIMIT_EXCEEDED";
export type ServicesWithoutCredits = "AI_STUDIO_3D_MODEL_GENERATOR" | "AI_STUDIO_AD_GENERATOR" | "AI_STUDIO_MAGIC_SWAP" | "AI_STUDIO_MULTI_IMAGE_FUSION" | "AI_STUDIO_PRODUCT_STAGING" | "AI_STUDIO_UPSCALER" | "AI_STUDIO_VIDEO_GENERATOR" | "AI_STUDIO_VTO";
export type serviceAvailabilityStatusQuery$variables = {
  serviceWithoutCredits: ServicesWithoutCredits;
};
export type serviceAvailabilityStatusQuery$data = {
  readonly serviceAvailabilityStatus: ServiceAvailabilityResult;
};
export type serviceAvailabilityStatusQuery = {
  response: serviceAvailabilityStatusQuery$data;
  variables: serviceAvailabilityStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serviceWithoutCredits"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "serviceWithoutCredits",
        "variableName": "serviceWithoutCredits"
      }
    ],
    "kind": "ScalarField",
    "name": "serviceAvailabilityStatus",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "serviceAvailabilityStatusQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "serviceAvailabilityStatusQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1a5187e45b8ef4d804f433ad7fde4fa2",
    "id": null,
    "metadata": {},
    "name": "serviceAvailabilityStatusQuery",
    "operationKind": "query",
    "text": "query serviceAvailabilityStatusQuery(\n  $serviceWithoutCredits: ServicesWithoutCredits!\n) {\n  serviceAvailabilityStatus(serviceWithoutCredits: $serviceWithoutCredits)\n}\n"
  }
};
})();

(node as any).hash = "224a570d712171f6c4edb365ff012fa8";

export default node;
